import { LitElement, html, svg } from 'lit';

export class IconAlertInfo16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Blå sirkel med bokstaven I</title><circle cx="8" cy="8" r="8" fill="currentColor"></circle><path fill="#fff" fill-rule="evenodd" d="M8 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM7.25 12a.75.75 0 0 0 1.5 0V8a.75.75 0 0 0-1.5 0v4Z" clip-rule="evenodd"></path></svg>`; }
}
if (!customElements.get('f-icon-alert-info16', IconAlertInfo16)) {
  customElements.define('f-icon-alert-info16', IconAlertInfo16);
}